const SHIPMENT_LIST_SECTION_NAME = ['shipments-all', 'pending', 'rejected', 'to_download'] as const;
export type ShipmentListSectionName = (typeof SHIPMENT_LIST_SECTION_NAME)[number];
export function isShipmentListSectionName(
  sectionName: string
): sectionName is ShipmentListSectionName {
  return SHIPMENT_LIST_SECTION_NAME.includes(sectionName as any);
}
